import {
  CREATE_DONER_FAIL,
  CREATE_DONER_PROCESSING,
  CREATE_DONER_SUCCESS,
  GET_DISTRICT_FAIL,
  GET_DISTRICT_PROCESSING,
  GET_DISTRICT_SUCCESS,
  GET_DONER_FAIL,
  GET_DONER_PROCESSING,
  GET_DONER_SUCCESS,
  GET_PROVINCE_FAIL,
  GET_PROVINCE_PROCESSING,
  GET_PROVINCE_SUCCESS,
} from "../../types";

const initialState = {
  loading: false,
  getProvince: [],
  getDistrict: [],
  getDoner: [],
};

export const donerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVINCE_PROCESSING:
      return {
        ...state,
        loading: true,
        getProvince: [],
      };
    case GET_PROVINCE_SUCCESS:
      return {
        ...state,
        loading: false,
        getProvince: action.payload,
      };
    case GET_PROVINCE_FAIL:
      return {
        ...state,
        loading: false,
        getProvince: [],
      };
    case GET_DISTRICT_PROCESSING:
      return {
        ...state,
        loading: true,
        getDistrict: [],
      };
    case GET_DISTRICT_SUCCESS:
      return {
        ...state,
        loading: false,
        getDistrict: action.payload,
      };
    case GET_DISTRICT_FAIL:
      return {
        ...state,
        loading: false,
        getDistrict: [],
      };
    case GET_DONER_PROCESSING:
      return {
        ...state,
        loading: true,
        getDoner: [],
      };
    case GET_DONER_SUCCESS:
      return {
        ...state,
        loading: false,
        getDoner: action.payload,
      };
    case GET_DONER_FAIL:
      return {
        ...state,
        loading: false,
        getDoner: [],
      };
    case CREATE_DONER_PROCESSING:
      return {
        ...state,
        loading: true,
      };
    case CREATE_DONER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_DONER_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
